import { render, staticRenderFns } from "./PaymentRequestList.vue?vue&type=template&id=6edf8d2a"
import script from "../../controllers/payment/payment-request-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/payment/payment-request-list.js?vue&type=script&lang=js&external"
import style0 from "./PaymentRequestList.vue?vue&type=style&index=0&id=6edf8d2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports